import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function AudienceSection() {
  const forWho = ['Personas que han sido dejadas recientemente y aún tienen contacto por redes o WhatsApp.', "Quienes están cansados de ser ignorados o dejados en 'visto'.", 'Hombres y mujeres que quieren recuperar su dignidad mientras buscan una segunda oportunidad.', 'Cualquier persona que sienta ansiedad paralizante al intentar comunicarse con su ex.'];
  const notForWho = ['Relaciones que involucran cualquier tipo de abuso físico o verbal.', 'Personas con órdenes de alejamiento o problemas legales vigentes.', 'Casos donde la relación terminó hace más de un año y no ha habido contacto alguno.'];
  return <section className="py-20 bg-[#05070d] border-y border-white/5" data-id="element-1">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-3">
          {/* For Who */}
          <FadeIn direction="right" data-id="element-4">
            <div className="bg-glass rounded-2xl p-8 border-t-4 border-t-[#00d9ff] h-full" data-id="element-5">
              <h3 className="text-2xl font-bold mb-8 flex items-center gap-3" data-id="element-6">
                <span className="text-[#00d9ff]" data-id="element-7">ESTO ES PARA TI</span> SI:
              </h3>
              <ul className="space-y-6" data-id="element-8">
                {forWho.map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-9">
                    <CheckCircle2 className="w-6 h-6 text-[#00d9ff] flex-shrink-0 mt-0.5" data-id="element-10" />
                    <span className="text-gray-300" data-id="element-11">{text}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Not For Who */}
          <FadeIn direction="left" delay={0.2} data-id="element-12">
            <div className="bg-glass rounded-2xl p-8 border-t-4 border-t-[#ff3366] h-full opacity-80" data-id="element-13">
              <h3 className="text-2xl font-bold mb-8 flex items-center gap-3" data-id="element-14">
                <span className="text-[#ff3366]" data-id="element-15">NO ES PARA TI</span> SI:
              </h3>
              <ul className="space-y-6" data-id="element-16">
                {notForWho.map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-17">
                    <XCircle className="w-6 h-6 text-[#ff3366] flex-shrink-0 mt-0.5" data-id="element-18" />
                    <span className="text-gray-400" data-id="element-19">{text}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}